import axios from 'axios';
import qs from 'qs'
axios.defaults.withCredentials = true;
axios.defaults.timeout = 8000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = true;
//获取cookie、
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

const service = axios.create({
  baseURL: 'https://dataapi.fenxiangqu.cn/', // api 的 base_url
  timeout: 8000, // request timeout
  withCredentials: true, // 允许跨域发生cookie
  headers: {
    'X-Access-Token': getCookie('dataPlatformID') || '',
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
  },
  paramsSerializer: function(params) {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  },
})
//POST传参序列化
service.interceptors.request.use((config) => {
  if(config.method  === 'post'){
    config.data = qs.stringify(config.data);
  }
  const token = getCookie('dataPlatformID'); //获取Cookie
  if (token) {
    if(config.params){
      config.params.token = token //后台接收的参数，后面我们将说明后台如何接收
    }else{
      config.params = {'token': token} //后台接收的参数，后面我们将说明后台如何接收
    }
  }
  return config;
},(error) =>{
  return Promise.reject(error);
});
// http response 拦截器
service.interceptors.response.use(
  response => {
//response.data.errCode是我接口返回的值，如果值为2，说明Cookie丢失，然后跳转到登录页，这里根据大家自己的情况来设定
    /*if(response.data.code == "Login") {
      router.push({
        path: '/login',
        query: {redirect: router.currentRoute.fullPath} //从哪个页面跳转
      })
    }*/
    return response;
  },
  error => {
    if(error){
      alert("抱歉，访问异常！")
    }
    return Promise.reject(error)
  });

export default service



// WEBPACK FOOTER //
// ./src/utils/http.js